import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getInvoices: {
    method: 'GET',
    url: `${configs.baseUrl}/api/invoice/`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getInvoices = async (params) => {
  const res = await resource.getInvoices(params)
  return res.body
}

export default {
  initResource,
  getInvoices,
}
